import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from "../../auth/auth-guard.service";
import { RoleGuard } from "../../auth/role-guard.service";

import { BasicLayoutComponent } from "../../../components/common/layouts/basicLayout.component";
import { ContactTypesComponent } from "../contact-types/contact-types.component";
import { ContactTypeListComponent } from "../contact-types/contact-type-list/contact-type-list.component";
import { ContactTypeManageComponent } from "../contact-types/contact-type-manage/contact-type-manage.component";

const typesRoutes: Routes = [
    {
        path: 'contacts',
        component: BasicLayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'types', component: ContactTypesComponent,
                children: [
                    {
                        path: '', component: ContactTypeListComponent,
                        children: [
                            { path: ':id/edit', component: ContactTypeManageComponent, canActivate: [RoleGuard] },
                            { path: 'new', component: ContactTypeManageComponent, canActivate: [RoleGuard] }
                        ]
                    }
                ]
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(typesRoutes)],
    exports: [RouterModule]
})
export class ContactTypesRoutingModule { }